import Head from "next/head";
import { make as SetWrappedPage } from "../../../src/set-wrapped10/SetWrapped10Page.bs";

export default function Wrapped() {
  return (
    <>
      <Head>
        <meta name="viewport" content="width=640px, maximum-scale=1" />
        <title>Set 10 Remix Rumble Wrapped - Teamfight Tactics</title>
      </Head>
      <SetWrappedPage />
    </>
  );
}

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: "blocking",
  };
}

export async function getStaticProps() {
  return {
    props: {},
  };
}
